import {Component, HostListener, OnInit} from '@angular/core';
import {ConfirmationService, MessageService} from "primeng/api";
import {TranslocoService} from "@ngneat/transloco";
import {AuthGuard} from "../../../common/auth-guard.service";
import {CommonMessagesService} from "../../../services/common-messages.service";
import {FiltersService} from "../../../services/filters.service";
import {SortOrder} from "../../../model/sort-order";
import {DefaultEncoder} from "../../../model/default-encoder";
import {DefaultEncoderFilters} from "../../../model/filters/default-encoder-filters";
import {DefaultEncodersService} from "../../../services/default-encoders.service";

@Component({
  selector: 'app-default-encoders',
  templateUrl: './default-encoders.component.html',
  styleUrls: ['./default-encoders.component.scss']
})
export class DefaultEncodersComponent implements OnInit {

  public defaultEncoders: DefaultEncoder[];
  public totalDefaultEncoders: number;
  public loadingDefaultEncoders: boolean;

  public rows = 10;
  public first = 0;
  public selected = [];

  public filtersVisible: boolean;
  public currentFilters: DefaultEncoderFilters;
  public filtersFilled: boolean;

  constructor(private defaultEncodersService: DefaultEncodersService,
              private messageService: MessageService,
              private i18n: TranslocoService,
              private confirmationService: ConfirmationService,
              public authGuardService: AuthGuard,
              private commonMessagesService: CommonMessagesService,
              private filtersService: FiltersService<DefaultEncoderFilters>) {
    this.currentFilters = new DefaultEncoderFilters();
  }

  ngOnInit(): void {
    if (this.filtersService.getCurrentFilters(this.constructor.name) !== undefined) {
      this.filtersFilled = true;
    }
    this.defaultEncoders = new Array(this.rows);
    Object.assign(this.currentFilters, this.filtersService.getCurrentFilters(this.constructor.name));
  }

  private loadDefaultEncoders(offset?: number, limit?: number): void {
    this.loadingDefaultEncoders = true;
    this.defaultEncoders = new Array(this.rows);
    this.trimFieldsForm(this.currentFilters);
    this.defaultEncodersService.getDefaultEncoders(offset, limit, this.filtersService.getCurrentFilters(this.constructor.name) === undefined ? this.currentFilters : this.filtersService.getCurrentFilters(this.constructor.name))
      .subscribe(response => {
        this.defaultEncoders = response.defaultEncoders;
        this.totalDefaultEncoders = response.totalElements;
        this.loadingDefaultEncoders = false;
      });
  }

  onPageChange(event): void {
    this.currentFilters.sortField = event.sortField;
    this.currentFilters.sortOrder = event.sortOrder < 0 ? SortOrder.DESCENDING : SortOrder.ASCENDING;
    this.loadDefaultEncoders(event.first / event.rows, event.rows);
  }

  resetFilters(): void {
    this.currentFilters = new DefaultEncoderFilters();
    this.currentFilters.sortField = 'name';
    this.currentFilters.sortOrder = SortOrder.ASCENDING;
    this.filtersFilled = false;
    this.filtersService.setCurrentFilters(undefined, this.constructor.name);
    this.applyFilters(true);
  }

  applyFilters(reset?: boolean): void {
    this.first = 0;
    if (reset !== true) {
      this.filtersService.setCurrentFilters(this.currentFilters, this.constructor.name);
      this.filtersFilled = true;
    }
    this.loadDefaultEncoders(this.first / this.rows, this.rows);
  }

  confirmAndDelete(defaultEncoder: DefaultEncoder): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => {
      this.deleteDefaultEncoder(defaultEncoder.name);
    });
  }

  deleteDefaultEncoder(name: string): void {
    this.defaultEncodersService.deleteDefaultEncoder(name).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadDefaultEncoders(this.first / this.rows, this.rows);
    }, error => {
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status);
    });
  }

  confirmAndDeleteSelected(): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => this.deleteSelected(), true);
  }

  deleteSelected(): void {
    if (this.selected.length === 0) {
      return;
    }
    const names = this.selected.map(item => item.name);

    this.defaultEncodersService.deleteDefaultEncoders(names).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadDefaultEncoders(this.first / this.rows, this.rows);
    }, error => {
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status, true);
    });
  }

  trimFieldsForm(filters: DefaultEncoderFilters): void {
    Object.keys(filters).forEach((key) => {
      if (filters[key] !== undefined && typeof filters[key] === 'string') {
        filters[key] = filters[key].trim();
      }
    });
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent): void {
    if (event.key === 'f') {
      this.filtersVisible = true;
    }
    if (event.key === 'Escape') {
      this.filtersVisible = false;
    }
  }

}
